import { Button, InfiniteScroll, printComponent, Progress } from "nq-component";
import BaseListPage from "../../../../base/BaseListPage";
import {
  countObjectUseCase,
  deleteObjectUseCase,
  findObjectUseCase,
  upsertUseCase,
} from "../../../../usecases/object";
import CardView from "../../../../components/common/CardView";
import DateRangePicker from "../../../../components/common/DateRangePicker";
import Table from "../../../../components/Table";
import withRouter from "../../../../withRouter";
import React from "react";
import InputFactory from "../../../../components/InputFactory";
import CancelRequestPagePresenter from "./CancelRequestPagePresenter";

class CancelRequestPage extends BaseListPage {
  constructor(props) {
    super(props);
    this.presenter = new CancelRequestPagePresenter(
      this,
      findObjectUseCase(),
      countObjectUseCase(),
      deleteObjectUseCase(),
      upsertUseCase(),
    );
    this.state = {
      objects: [],
      type: [],
      // status: [],
      filteredLeaves: "",
      count: 0,
      limit: 10,
      current: 1,
    };
  }

  getCollectionName() {
    return "leave_request";
  }
  // edit function
  async handleViewData(obj) {
    this.navigateTo(`/approve/${this.getCollectionName()}/${obj.id}`);
    // this.refetchData();
  }

  async refetchData() {
    const objects = await this.presenter.getObjects();
    this.filterSubmit({});
    return objects;
  }

  getcurrent() {
    return this.getCurrentUser().employee;
  }

  onClickPagination(page) {
    this.presenter.setCurrentPage(page);
  }

  setObjects(objects) {
    this.setState({ objects });
  }

  setCurrent(current) {
    this.setState({ current });
  }

  render() {
    const schema = this.getSchema(this.getCollectionName());
    const { objects, loading, count, current, limit } = this.state;
    console.log("objects: ", objects);
    if (!schema) return <Progress />;
    const excludeFieldsFather = [
      "selectedType",
      "halfDay",
      "startdate",
      "enddate",
      "createdAt",
      "duration",
      "stats",
      "employee",
      "cancelReason",
    ];
    const applyField = Object.keys(schema.fields).filter(
      (key) => !excludeFieldsFather.includes(key),
    );
    return (
      <>
        <div>
          <InfiniteScroll className="h-100" loadMore={this.loadMore.bind(this)}>
            <div className="">
              <CardView style={{ borderRadius: 0 }}>
                <div className="row d-flex align-items-center">
                  <div className="d-flex mb-1">
                    {Object.keys(schema.filters || {})
                      .filter((field) => field !== "stats")
                      .map((field) => {
                        let { type, ...options } = schema.filters[field];
                        return (
                          <InputFactory
                            key={field}
                            className="ms-1"
                            type={type}
                            field={field}
                            where={{}}
                            onChange={this.onChangeFilter.bind(this, type)}
                            {...options}
                          />
                        );
                      })}
                    <div className="ms-1">
                      <DateRangePicker
                        fields={["startdate", "enddate", "employee.id"]}
                        onFilter={(filterObj) => {
                          // this.searchSubmit(filterObj);
                          if (Object.keys(filterObj).length > 0) {
                            const updatedAtDate = new Date(
                              filterObj.enddate.$lte,
                            );
                            updatedAtDate.setDate(updatedAtDate.getDate() + 1);

                            const updatedFilterObj = {
                              ...filterObj,
                              enddate: {
                                $lte: updatedAtDate.toISOString().split("T")[0],
                              },
                            };
                            this.searchSubmit(updatedFilterObj);
                          } else {
                            this.searchSubmit(filterObj);
                          }
                        }}
                      />
                    </div>
                  </div>
                </div>
              </CardView>
              <div
                style={{
                  marginTop: "20px",
                  width: "100%",
                }}
              >
                <CardView style={{ borderRadius: 0 }}>
                  <div className="d-flex align-items-center justify-content-between">
                    <h4 className="text-primary">{schema.label}</h4>
                  </div>
                </CardView>
              </div>

              <Table
                // empPointer={empPointer}
                viewPayroll={this.handleViewData.bind(this)}
                stepIncrement={(data) =>
                  this.presenter.handleConfirmationDialog("Approve", data)
                }
                separateEmployee={(data) =>
                  this.presenter.handleConfirmationDialog("Disapprove", data)
                }
                progress={loading}
                refetch={this.refetchData.bind(this)}
                fields={schema.fields}
                objects={objects}
                collection={schema}
                count={count}
                limit={limit}
                current={current}
                loadPagination={this.onClickPagination.bind(this)}
                actionsList={[
                  {
                    // label: <i className="bi bi-pencil-square"/>,
                    actionType: "OB Management List",
                  },
                ]}
                excludeFields={Object.keys(schema.fields).reduce((acc, key) => {
                  const options = schema.fields[key];
                  if (options.read === false) {
                    acc.push(key);
                  }
                  switch (options._type || options.type) {
                    case "Relation":
                    case "Array":
                    case "Object":
                    case "File":
                      acc.push(key);
                      break;
                    default:
                  }
                  return acc;
                }, applyField)}
                onClickItem={this.onClickItem.bind(this)}
              />
            </div>
          </InfiniteScroll>
        </div>
      </>
    );
  }
}

export default withRouter(CancelRequestPage);
